module.exports = [{
      plugin: require('/home/dwi/kerja/yuso-front3/pivotal-ui/styleguide/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
